import {
  useAsync
} from "./chunk-FVZAR5OH.mjs";

// src/useCategoryDetails.ts
var createUseCategoryDetails = (httpClient) => (categoryName) => {
  return useAsync(
    async () => {
      const response = await httpClient.get(
        `/columns/${categoryName}`
      );
      return response.data;
    },
    { deps: [categoryName] }
  );
};
export {
  createUseCategoryDetails
};
